import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import TituloAdmin from '@components/TituloAdmin';
import BotonBuscar from '@components/BotonBuscar';
import LoadingOverlay from '@components/LoadingOverlay';
import LabelCarga from '@components/LabelCarga';
import Notify from '@components/Notify';

import { getLogsApi } from "@api/logsApi";

import { cajaPrincipalStyle } from '@styles/cajaPrincipal';
import { cajaContenedorAdminStyle } from '@styles/cajaContenedorAdmin';
import Label from '@components/Label';
import { selectStyle } from '@styles/selecsEstylos';
import '@styles/select2Custom.css';
import '@styles/modernTable.css';

function Logs() {
  const navigate = useNavigate();
  const [logs, setLogs] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [tipo, setTipo] = useState('agendamientos');
  const [fechaInicio, setFechaInicio] = useState(new Date().toISOString().split('T')[0]);
  const [fechaFin, setFechaFin] = useState(new Date().toISOString().split('T')[0]);
  const [notify, setNotify] = useState({ open: false, message: '', type: 'success' });

  const tipoLogsSelectRef = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const idUsu = localStorage.getItem('idUsu');
    if (!idUsu && !token) navigate('/login');
  }, [navigate]);

  // Select2 — mismo criterio que CitasExtras.jsx
  useEffect(() => {
    try {
      const $ = window.$;
      if (!tipoLogsSelectRef.current || !$?.fn?.select2) {
        return undefined;
      }
      const $el = $(tipoLogsSelectRef.current);
      if ($el.hasClass('select2-hidden-accessible')) {
        $el.off('change.select2react');
        $el.select2('destroy');
      }
      $el.select2({
        placeholder: '-- Tipo de logs --',
        allowClear: false,
        width: '100%',
        theme: 'default',
        minimumResultsForSearch: 0,
        language: {
          noResults: function () { return 'No se encontraron resultados'; },
          searching: function () { return 'Buscando...'; },
        },
      });
      $el.on('change.select2react', function () {
        const v = String($el.val() || 'agendamientos');
        setTipo(v);
        setLogs([]);
      });
      $el.val(tipo).trigger('change');
      return () => {
        if ($el.hasClass('select2-hidden-accessible')) {
          $el.off('change.select2react');
          $el.select2('destroy');
        }
      };
    } catch (e) {
      console.error('Error inicializando Select2 (tipo logs):', e);
      return undefined;
    }
  }, []);

  useEffect(() => {
    try {
      const $ = window.$;
      const el = tipoLogsSelectRef.current;
      if (!el || !$?.fn?.select2) return;
      const $el = $(el);
      if (!$el.hasClass('select2-hidden-accessible')) return;
      if ($el.val() !== tipo) {
        $el.val(tipo).trigger('change');
      }
    } catch (_) {
      /* noop */
    }
  }, [tipo]);

  const handleConsultar = async () => {
    try {
      setCargando(true);
      const response = await getLogsApi({ 
        tipo,
        fecha_inicio: fechaInicio, 
        fecha_fin: fechaFin,
        limit: 100
      });
      setLogs(response?.result || []);
      if (!response?.result?.length) {
        setNotify({ open: true, message: 'No se encontraron logs en ese rango', type: 'info' });
      }
    } catch (error) {
      console.error(error);
      setNotify({ open: true, message: 'Error al consultar logs', type: 'error' });
    } finally {
      setCargando(false);
    }
  };

  return (
    <div id="cajaPrincipal" style={cajaPrincipalStyle}>
      <LoadingOverlay visible={cargando} />
      <Notify open={notify.open} message={notify.message} type={notify.type} onClose={() => setNotify({ ...notify, open: false })} />
      
      <TituloAdmin 
        titulo="Logs de Sistema" 
        imagen_titulo="extras"
        subtitulo="Consultar historial de logs y transacciones del sistema" 
      />

      <div style={cajaContenedorAdminStyle}>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'stretch',
            columnGap: '7vh',
            rowGap: '2.5vh',
            marginBottom: '3vh',
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', minWidth: 'min(100%, 32vh)' }}>
            <Label>Tipo de Logs:</Label>
            <select
              ref={tipoLogsSelectRef}
              value={tipo}
              onChange={(e) => {
                setTipo(e.target.value);
                setLogs([]);
              }}
              style={{ ...selectStyle, marginTop: 'auto' }}
            >
              <option value="agendamientos">Logs agendamientos</option>
              <option value="bold">Logs Bold</option>
            </select>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Label>Fecha Inicio:</Label>
            <input
              type="date"
              value={fechaInicio}
              onChange={(e) => setFechaInicio(e.target.value)}
              style={{ ...selectStyle, marginTop: 'auto' }}
            />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Label>Fecha Fin:</Label>
            <input
              type="date"
              value={fechaFin}
              onChange={(e) => setFechaFin(e.target.value)}
              style={{ ...selectStyle, marginTop: 'auto' }}
            />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', paddingLeft: '1vh' }}>
            <Label aria-hidden style={{ visibility: 'hidden', pointerEvents: 'none' }}>
              &nbsp;
            </Label>
            <BotonBuscar
              onClick={handleConsultar}
              disabled={cargando}
              titulo="Consultar logs en el rango de fechas"
              varianteFiltros
            />
          </div>
        </div>

        <div className="modern-table-container">
          {cargando ? (
            <LabelCarga nombre="logs" />
          ) : (
            <table className="modern-table">
              <thead>
              <tr>
                <th>ID</th>
                <th>Fecha Sistema</th>
                {tipo === 'agendamientos' && <th>Request ID</th>}
                {tipo === 'agendamientos' && <th>Request Sol</th>}
                {tipo === 'bold' && <th>Order ID</th>}
                <th>Message</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((log, i) => (
                <tr key={log.id || i}>
                  <td>{log.id}</td>
                  <td>{log.fechaSis || log.fecha_creacion || 'N/A'}</td>
                  {tipo === 'agendamientos' && <td>{log.requestId || 'N/A'}</td>}
                  {tipo === 'agendamientos' && <td>{log.requestSol || 'N/A'}</td>}
                  {tipo === 'bold' && <td>{log.order_id || 'N/A'}</td>}
                  <td style={{ maxWidth: '400px', wordWrap: 'break-word' }}>{log.message || log.stack || 'N/A'}</td>
                </tr>
              ))}
            </tbody>
          </table>
          )}
        </div>
      </div>
    </div>
  );
}

export default Logs;
